var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"paymentresult"}},[_c('NavTop',{attrs:{"title":"支付结果","islink":true,"linkurl":"/index"}}),_c('van-empty',{staticClass:"custom-image",attrs:{"image":_vm.okimg,"description":"支付成功"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }